module.exports = __webpack_public_path__ + "img/card-background.d5538f4f.png";